import React from 'react'
import { connect } from 'react-redux'
import Helmet from 'react-helmet'

import PopoverOnClick from 'components/Utils/Popover/PopoverOnClick'
import { selectors as NotificationsSelectors } from 'data/notifications'

import NotificationsPopover from './Popover'
import IconButton from 'components/Utils/IconButton'
import { NotificationBellIcon } from 'components/Utils/Icons'
import CounterBadge from 'components/Utils/CounterBadge'

function NotificationsDropdown({ unreadNotificationsCount }) {
  const isActive = unreadNotificationsCount > 0
  return (
    <PopoverOnClick
      position="bottom"
      align="end"
      containerStyle={{ zIndex: 9 }}
      content={({ closePopover }) => (
        <NotificationsPopover onClosePopover={closePopover} />
      )}
    >
      <div className="pointer">
        <Helmet
          meta={[{ name: 'browserx-badge', content: unreadNotificationsCount }]}
        />

        {isActive && (
          <CounterBadge
            count={unreadNotificationsCount}
            color="secondary"
            size="large"
          />
        )}

        {!isActive && (
          <div>
            <IconButton>
              <NotificationBellIcon size={16} />
            </IconButton>
          </div>
        )}
      </div>
    </PopoverOnClick>
  )
}

export default connect(state => ({
  unreadNotificationsCount: NotificationsSelectors.getUnreadNotificationsCount(
    state
  ),
}))(NotificationsDropdown)
